import { render } from "./seed.vue?vue&type=template&id=f9d1dc28&scoped=true"
import script from "./seed.vue?vue&type=script&lang=js"
export * from "./seed.vue?vue&type=script&lang=js"

import "./seed.vue?vue&type=style&index=0&id=f9d1dc28&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9d1dc28"]])

export default __exports__